<template>
  <div style="width: 100%">
    <el-table
      @selection-change="handleSelectionChange"
      @current-change="handleCurrentChange"
      v-loading="loading"
      :tree-props="treeProps ? treeProps : ''"
      :row-key="rowKey"
      :data="list"
      style="width: 100%" 
      :height="height"
      ref="multipleTable"
      :span-method="objectSpanMethod"
	  :size="sizeSmall"
    >
      <el-table-column
        v-if="selection"
        type="selection" 
        width="30"
      >
      </el-table-column>
      <!-- 自定义单选列 -->
      <el-table-column width="100" align="center" label="选择" v-if="!multiply">
        <template slot-scope="scope">
          <el-radio
            :label="scope.$index"
            v-model="selectedRow"
            @change="selectRow(scope.row)"
          ></el-radio>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in tableList"
        :align="item.align || 'center'"
        :key="index"
        :width="item.width"
        v-bind="item"
        :fixed="item.fixed || false"
      >
        <template #default="scope">
          <slot :name="item.prop" :row="scope.row" :index="scope.$index">
            {{
              scope.row[item.prop]
                ? scope.row[item.prop]
                : item.label
                ? (item.default || "-")
                : ""
            }}
          </slot>
        </template>
      </el-table-column>
    </el-table>
	 <slot name="footerPage"></slot>
    <div class="pageclass"
      v-if="total > 0"
      :style="{ textAlign: pageAlign, padding: pagePadding }"
    >
      <!-- <el-pagination
        background
        :hide-on-single-page="true"
        @current-change="changepage"
        :current-page="page"
        :page-size="pagesize"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination> -->
	  <el-pagination
	    background  :small="sizeSmall=='mini'?true:false"
	    @size-change="handleSizeChange"
	    @current-change="changepage"
	    :current-page="page"
	    :page-size="pagesize"
		:page-sizes="pageSizeArr"
	    :layout="(sizesType?'sizes,':'')+'total, prev, pager, next, jumper'"
	    :total="total"
	  ></el-pagination>
    </div>
  </div>
</template>

<script>
// import { eltips } from '@/util/util.js';
export default {
  name: "baseTable",
  props: {
	  pageSizeArr:{
		  type:Array,
		  default:() =>[20,50,100, 200, 300, 400]
	  },
	  sizesType:{
		  type: Boolean,
		  default: false,
	  },
	  sizeSmall:{
		  type: String,
		  default: '',
	  },
    // 从父组件接收的方法
    objectSpanMethod: {
      type: Function,
      required: false,
    },
    treeProps: {
      type: Object,
      default: () => {
        return {
          children: "children",
          hasChildren: "hasChildren",
        };
      },
    },
    rowKey: {
      typeof: String,
      default: "category_id",
    },
    selection: {
      type: Boolean,
      default: false,
    },
    tableList: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    page: {
      type: Number,
      default: 1,
    },
    pagesize: {
      type: Number,
      default: 10,
    },
    pageAlign: {
      type: String,
      default: "center",
    },
    pagePadding: {
      type: String,
      default: "20px 0",
    },
    multiply: {
      type: Boolean,
      default: true,
    },
    height:{
      type:Number
    }
  },
  data() {
    return {
      selectedRow: null, // 存储选中行的索引
      currentSelected: null, // 存储选中行的数据
    };
  },
  created() {},
  methods: {
	  handleSizeChange(e){
		console.log(e) 
		 this.$emit("changeSize", e);
	  },
    changepage(e) {
      this.$emit("changePage", e);
    },
    handleSelectionChange(e) {
      if (this.selection) {
        this.$emit("tableSelectionChange", e);
      }
    },
    // 单选处理函数
    selectRow(row) {
      this.currentSelected = row;
      // 手动设置高亮行
      this.$refs.multipleTable.setCurrentRow(row);
    },

    // 高亮行变化时的回调
    handleCurrentChange(currentRow) {
      if (currentRow) {
        this.selectedRow = this.list.indexOf(currentRow);
        this.currentSelected = currentRow;
        this.$emit("tableSelectionChange", this.currentSelected);
      }
    },
    selectAll() {
      this.$refs.multipleTable.toggleAllSelection();
    },
    // 清空所有选中行
    clearSelection() {
      this.$refs.multipleTable.clearSelection();
    },
    // 设置选中行（传入要选中的行数组）
    setSelection(rows) {
      this.$refs.multipleTable.clearSelection();
      if (rows && rows.length) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row, true);
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-radio__label {
  display: none !important;
}
/deep/.el-table th{
  // background: #f6f7fb;
  background: #f9f9f9;
}
// /deep/.el-table-column--selection .cell{
//   padding-left: 50px;
// }
/deep/ .el-table td{
  border-bottom: 1px solid #f9f9f9;
}
/deep/.el-table th{
  border-bottom: 1px solid #f9f9f9;
}
/deep/.el-table::before{
  background: #f9f9f9;
}
.pageclass {
  clear: both;
  display: block !important;
  visibility: visible !important;
  position: relative;
  z-index: 100;
}
</style>
